export default __webpack_public_path__ + "static/media/icon-facebook.4be3172a.svg";